module.exports = __webpack_public_path__ + "static/img/banner1.8f05045.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner1.png
// module id = CMrX
// module chunks = 0